<ng-container *transloco="let t">
  <app-page-template [showBreadcrumbs]="true">
    <ng-template *ngTemplateOutlet="header"></ng-template>
    <div class="container pb-300-228">
      <div class="pt-60-50">
        <div class="row">
          <div class="col-12 col-xxl-6">
            <div class="row row-custom-padding">
              <div class="col-6">
                <button type="button"
                        class="registration-btn btn btn-primary square-button w-100 btn-left-align fw-semibold btn-grey btn-no-tap"
                        (click)="goToRegistrationInfo()">
                  <img src="assets/img/checkmark.svg" alt="Tracy logo" class="pe-2">
                  {{ t('app.register.to.race.info')|uppercase }}
                </button>
              </div>
              <div class="col-6">
                <button type="button"
                        class="registration-btn btn btn-primary square-button w-100 btn-left-align fw-medium fw-semibold btn-grey btn-no-tap"
                        (click)="confirmRegistration(false)">
                  @if (registerToRaceFormType === RegisterToRaceFormType.CONFIRMATION
                  && event?.paymentSettings?.paymentType?.includes(EventPaymentType.PAYMENT_BY_BANK_TRANSFER)) {
                    <img
                      src="assets/img/{{ wspayConfirmation?.paymentStatus === WsPaymentStatus.ERROR ? 'x' : 'checkmark' }}.svg"
                      alt="{{ wspayConfirmation?.paymentStatus === WsPaymentStatus.ERROR ? 'Error' : 'Success' }}"
                      class="pe-2">
                  }
                  @if (registerToRaceFormType === RegisterToRaceFormType.PAYMENT) {
                    <img src="assets/img/checkmark.svg" alt="Checkmark" class="pe-2">
                  }
                  {{ t('app.register.to.race.confirmation')|uppercase }}
                </button>
              </div>
            </div>
          </div>
          <div class="col-12 col-xxl-6">
          </div>
        </div>
        <div class="row pt-20-10">
          <div class="col-12 col-xxl-6">
            @if (registerToRaceFormType === RegisterToRaceFormType.REGISTRATION_INFO) {
              <ng-template *ngTemplateOutlet="registrationInfo"></ng-template>
            }
            @if (registerToRaceFormType === RegisterToRaceFormType.CONFIRMATION) {
              <ng-template *ngTemplateOutlet="confirmation"></ng-template>
            }
            @if (registerToRaceFormType === RegisterToRaceFormType.PAYMENT) {
              <ng-template *ngTemplateOutlet="paymentStatus"></ng-template>
            }
          </div>
          <ng-template *ngTemplateOutlet="summary"></ng-template>
        </div>
      </div>
    </div>
    @if (!isPreviewComponent) {
      <app-footer/>
    }
  </app-page-template>

  <ng-template #header>
    <div class="container container-no-padding-sm">
      <app-page-header-public [currentItem]="event"/>
      <app-info-section-public [currentItem]="event" [languages]="languages" [currentItemType]="CurrentItemType.EVENT">
        <div slot="title-slot">
          <h1 class="info-area__title flex-grow-1 trim-text">
            <app-language-output [hrLabel]="event?.name" [enLabel]="event?.nameEng" [itLabel]="event?.nameIta"
                                 [siLabel]="event?.nameSlo" [defaultLanguage]="event?.defaultLanguage"
                                 [languages]="languages"/>
            {{ " - " }}
            <app-language-output [hrLabel]="race?.name" [enLabel]="race?.nameEng" [itLabel]="race?.nameIta"
                                 [siLabel]="race?.nameSlo" [defaultLanguage]="event?.defaultLanguage"
                                 [languages]="languages"/>
          </h1>
        </div>
      </app-info-section-public>
    </div>
    <div class="container-fluid container-no-padding">
      <div class="horizontal-separator">
      </div>
    </div>
  </ng-template>

  <ng-template #registrationInfo>
    @for (competitorRegistration of registrations;track $index) {
      <div [class.pt-48-38]="$index > 0">
        <app-section-card
          [title]="(this.registrations[$index].firstName?.length ?? 0 > 0 ||
                      this.registrations[$index].lastName?.length ?? 0 > 0 ) ? (this.registrations[$index].firstName ??
                       '')
                      + ' ' + (this.registrations[$index].lastName ?? '') : t('app.register.to.race.participant')">
          @if (isRemoveNewRacerVisible($index)) {
            <ng-container slot="trailing-icon">
              <img src="assets/img/delete-icon.png" alt="{{t('app.register.to.race.removeRacer')}}"
                   class="pe-3 cursor-pointer"
                   (click)="removeRacer()">
            </ng-container>
          }
          <app-register-to-race-item [event]="event" [race]="race" [index]="$index"
                                     [competitorRegistration]="competitorRegistration"
                                     [isFirstRegistration]="$index === 0"
                                     [registerForMySelf]="$index === 0 ? registerForMySelf : false"
                                     [countries]="countries" [tshirtSizes]="tshirtSizes" [meals]="meals"
                                     [transports]="transports" [genders]="genders" [currencies]="currencies"
                                     [disciplines]="disciplines"
                                     [registerToRaceUserTypeState]="registerToRaceUserTypeState"
                                     [currentUserDetails]="currentUserDetails"
                                     [applicationFormSettings]="applicationFormSettings"
                                     [raceCommercialItems]="raceCommercialItems"
                                     [raceAdditionalItems]="raceAdditionalItems"
                                     [registerHelper]="registerHelper"
                                     [isTeamRegistration]="registerHelper!.isTeamRegistration()"
                                     [languages]="languages"
                                     (changeRace)="onChangeRace($event)"
                                     (changeRegisterToRaceForMyself)="onChangeRegisterToRaceForMyself($event)"
                                     (onChangeFirstName)="registerHelper!.onChangeFirstName($event, $index)"
                                     (onChangeLastName)="registerHelper!.onChangeLastName($event, $index)"
                                     (onChangeRegistrationFeeId)="registerHelper!.onChangeRegistrationFeeId($event)"
                                     (onChangeEmail)="registerHelper!.onChangeEmail($event, $index)"
                                     (onChangeRaceAdditionalItems)="registerHelper!.onChangeRaceAdditionalItems($event, $index)"/>
        </app-section-card>
      </div>
    }
    <div class="d-none d-xxl-flex">
      <ng-container *ngTemplateOutlet="racerButtonsTemplate"></ng-container>
    </div>
  </ng-template>

  <ng-template #confirmation>
    <app-section-card [title]="t('app.register.to.race.confirmation.registration')" [enableToggle]="false">
      <div class="px-32">
        <div class="fs-18 pb-20">
          {{
            t('app.register.to.race.confirmation.well.done',
              {name: registrations[0].firstName})
          }}
        </div>
        <div class="fw-bold fs-30-28 pb-20">{{
            t('app.register.to.race.confirmation.you.are.now.registered')
          }}
        </div>
        <div class="fs-18">
          <div class="pb-38-34">{{ t('app.register.to.race.confirmation.we.have.sent.you.an.email') }}</div>
          @if (registerToRaceResponse?.endDateForPayment && !registrationWithoutPayment) {
            <div class="pb-16 fw-bold color-primary">{{
                t('app.register.to.race.confirmation.registration.is.valid.until', {
                  date: registerToRaceResponse!.endDateForPayment! |
                    date:
                    'dd.MM.yyyy HH:mm:ss': undefined: translocoService.getActiveLang()
                })
              }}
            </div>
            <div class="pb-16">{{ t('app.register.to.race.confirmation.please') }}<span
              class="fw-bold">{{
                t('app.register.to.race.confirmation.make.the.payment.by.the.specific.date')
              }}</span>{{
                t('app.register.to.race.confirmation.in.order.to.be.able.to.participate.the.race')
              }}
            </div>
          }
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center">
          <div class="d-flex justify-content-center pb-40-48">
            <img class="img-fluid" src="assets/img/svg/successful_payment.svg" alt="Successful payment" width="460">
          </div>
          <app-rounded-button [label]="t('app.common.close')" (onClick)="onClose()"/>
        </div>
      </div>
      @if (event?.paymentSettings?.mandatoryPayment !== true && event?.paymentSettings?.paymentType?.includes(
        EventPaymentType.PAYMENT_BY_BANK_TRANSFER) && !registrationWithoutPayment) {
        <div class="horizontal-separator my-4"></div>
        <div class="px-32 fs-18-16">
          <div class="fw-bold mb-20">{{ t('app.register.to.race.confirmation.payment.info') }}</div>
          <div>{{
              t('app.register.to.race.confirmation.payment.is.made.to',
                {
                  organiser: registerToRaceResponse?.bankTransferInfo?.barcodePaymentDTO?.payee?.name
                    ?? '',
                  city: registerToRaceResponse?.bankTransferInfo?.barcodePaymentDTO?.payee?.city ??
                    '',
                  country: registerToRaceResponse?.bankTransferInfo?.barcodePaymentDTO?.payee?.country ??
                    ''
                })
            }}
          </div>
          <div>{{
              t('app.register.to.race.confirmation.payment.bank.account', {
                bankAccount:
                  registerToRaceResponse?.bankTransferInfo?.barcodePaymentDTO?.payeeIban ?? ''
              })
            }}
          </div>
          <div>{{
              t('app.register.to.race.confirmation.payment.reference', {
                payeeReferenceNumber:
                  registerToRaceResponse?.bankTransferInfo?.barcodePaymentDTO?.payeeReferenceNumber ?? ''
              })
            }}
          </div>
          <div>{{
              t('app.register.to.race.confirmation.payment.description', {
                paymentDescription:
                  registerToRaceResponse?.bankTransferInfo?.barcodePaymentDTO?.paymentDescription ?? ''
              })
            }}
          </div>
          <div>{{
              t('app.register.to.race.confirmation.payment.model', {
                payeeModel:
                  registerToRaceResponse?.bankTransferInfo?.barcodePaymentDTO?.payeeModel ?? ''
              })
            }}
          </div>
        </div>
      }
      @if (event?.paymentSettings?.paymentType?.includes(EventPaymentType.ONLINE_PAYMENT) &&
      !registrationWithoutPayment) {
        <div class="horizontal-separator my-4"></div>
        <div class="fs-18">
          <div class="fw-bold mb-20 text-uppercase px-32">{{
              t('app.register.to.race.confirmation.payment.options')
            }}
          </div>
          <div class="row">
            <div class="col-6">
              <app-rounded-button [label]="t('app.register.to.race.pay.with.card')" (onClick)="onContinueWithPayment()"
                                  [btnClass]="'btn-red w-100'"
              />
            </div>
          </div>
        </div>
      }
      @if (event?.paymentSettings?.mandatoryPayment !== true &&
      event?.paymentSettings?.paymentType?.includes(EventPaymentType.PAYMENT_BY_BANK_TRANSFER)
      && !registrationWithoutPayment) {
        <div class="horizontal-separator my-4"></div>
        <div class="d-flex align-items-center justify-content-center flex-column">
          <div class="fw-bold pt-4">{{
              t('app.register.to.race.confirmation.use.code.for.online.banking')
            }}
          </div>
          @if (registerToRaceResponse?.bankTransferInfo?.barcode) {
            <img src="data:image/png;base64,{{registerToRaceResponse!.bankTransferInfo!.barcode}}"
                 alt="barcode"
                 class="pt-4 img-fluid">
          }
          <div class="pt-4">
            <app-rounded-button [label]="t('app.register.to.race.close')" (onClick)="onClose()"
            />
          </div>
        </div>
      }
    </app-section-card>
  </ng-template>

  <ng-template #paymentStatus>
    <app-section-card [title]="t('app.register.to.race.payment.summary')" [enableToggle]="false">
      @if (wspayConfirmation?.paymentStatus === WsPaymentStatus.SUCCESS) {
        <div class="px-32">
          <div class="fs-18 pb-20">{{
              t('app.register.to.race.payment.well.done', {
                name:
                  ((wspayConfirmation?.competitors?.length ?? 0) > 0 ?
                    (wspayConfirmation!.competitors![0].firstName ?? '') : '')
              })
            }}
          </div>
          <div class="fw-bold fs-30-28 pb-20">{{ t('app.register.to.race.payment.success.title') }}</div>
          <div class="fs-16">
            <div class="pb-16">{{ t('app.register.to.race.payment.success.desc') }}
            </div>
            <div class="d-flex justify-content-center align-items-center flex-column">
              <div class="py-3">
                <img src="assets/img/payment-success.svg" alt="Confirmation" class="pe-2 img-fluid">
              </div>
              <div class="mt-30">
                <app-rounded-button [label]="t('app.register.to.race.close')" (onClick)="onClose()"
                />
              </div>

            </div>
          </div>
        </div>
      }

      @if (wspayConfirmation?.paymentStatus === WsPaymentStatus.ERROR) {
        <div class="px-32">
          <div class="fs-18 pb-20">
            {{
              t('app.register.to.race.payment.ups', {
                name:
                  ((wspayConfirmation?.competitors?.length ?? 0) > 0 ?
                    (wspayConfirmation!.competitors![0].firstName ?? '') : '')
              })
            }}
          </div>
          <div class="fw-bold fs-30-28 pb-20">{{ t('app.register.to.race.payment.error.title') }}</div>
          <div class="fs-16">
            <div class="pb-16">{{ t('app.register.to.race.payment.error.desc') }}
            </div>
            <div class="d-flex justify-content-center align-items-center flex-column">
              <div class="py-3">
                <img src="assets/img/payment-error.svg" alt="Canceled" class="pe-2 img-fluid">
              </div>
              <div class="mt-30">
                <app-rounded-button [label]="t('app.register.to.race.close')" (onClick)="onClose()"
                />
              </div>
            </div>
          </div>
        </div>
      }

      @if (wspayConfirmation?.paymentStatus === WsPaymentStatus.CANCEL) {
        <div class="px-32">
          <div class="fs-18 pb-20">{{
              t('app.register.to.race.payment.dear', {
                name:
                  ((wspayConfirmation?.competitors?.length ?? 0) > 0 ?
                    (wspayConfirmation!.competitors![0].firstName ?? '') : '')
              })
            }}
          </div>
          <div class="fw-bold fs-30-28 pb-20">{{ t('app.register.to.race.payment.canceled.title') }}</div>
          <div class="fs-16">
            <div class="pb-16">{{ t('app.register.to.race.payment.canceled.desc') }}
            </div>
            <app-rounded-button [label]="t('app.register.to.race.close')" (onClick)="onClose()"
                                [btnClass]="'mt-30 pt-65-45'"
            />
          </div>
        </div>
      }
    </app-section-card>
  </ng-template>

  <ng-template #summary>
    <div class="col-12 col-xxl-6 fs-18" [class.pt-48-38]="isSmallerThanXXL">
      <app-section-card [title]="t('app.register.to.race.summary')" [enableToggle]="false">
        <div class="h-100">
          <form [formGroup]="inputForm">
            <ng-container formArrayName="coupons">
              @for (competitorRegistrationSummaryItem of getSummaryCompetitorItems();track $index) {
                <div
                  class="pb-2 px-32 pt-30-28">{{ t('app.register.to.race.participant') }}: <span
                  class="fw-bold fs-18-16">{{
                    (competitorRegistrationSummaryItem.firstName ?? '') + ' ' +
                    (competitorRegistrationSummaryItem.lastName ?? '')
                  }}</span></div>
                <!-- registration fee output-->
                <div class="px-32 d-flex justify-content-between pb-38-34">
                  @if (registerToRaceFormType === RegisterToRaceFormType.PAYMENT) {
                    <app-register-to-race-fee-item-output [race]="race" [defaultLanguage]="event?.defaultLanguage"
                                                          [eventCurrencyLabel]="eventCurrencyLabel"
                                                          [competitorRegistrationSummaryItem]="competitorRegistrationSummaryItem"
                                                          [languages]="languages"/>
                  } @else {
                    <app-register-to-race-fee-item-output [race]="race" [defaultLanguage]="event?.defaultLanguage"
                                                          [eventCurrencyLabel]="eventCurrencyLabel"
                                                          [raceCommercialItems]="raceCommercialItems"
                                                          [competitorRegistrationSummaryItem]="competitorRegistrationSummaryItem"
                                                          [languages]="languages"/>
                  }
                </div>
                @for (item of competitorRegistrationSummaryItem.raceAdditionalPricingItems;track $index) {
                  <!-- selected registration additional pricing items-->
                  <div class="px-32 d-flex justify-content-between pb-38-34">
                    <app-register-to-race-additional-item-output [defaultLanguage]="event?.defaultLanguage"
                                                                 [eventCurrencyLabel]="eventCurrencyLabel"
                                                                 [raceAdditionalPricingItem]="item"
                                                                 [languages]="languages"/>
                  </div>
                }
                @if (registerToRaceFormType !== RegisterToRaceFormType.REGISTRATION_INFO && getSummaryCompetitorItems()
                && (getSummaryCompetitorItems()!.length - 1) !== $index) {
                  <div class="horizontal-separator"></div>
                }
                @if (registerToRaceFormType === RegisterToRaceFormType.REGISTRATION_INFO) {
                  @if (!registerHelper?.isTeamRegistration()) {
                    <div class="horizontal-separator"></div>
                    <ng-container [formGroupName]="$index">
                      <div class="d-flex align-items-start pt-30-28 pb-38-34">
                        <div class="flex-grow-1 me-3">
                          <app-input formControlName="coupon" [formId]="'coupon'+$index"
                                     label="app.register.to.race.coupon"/>
                        </div>
                        <div class="mt-30">
                          <app-rounded-button [label]="t('app.register.to.race.apply')"
                                              (onClick)="onApplyCoupon($index, coupons.at($index).value.coupon)"
                                              [isDisabled]="isApplyCouponButtonDisabled($index, coupons.at($index).value.coupon)"
                          />
                        </div>
                      </div>
                    </ng-container>
                  }
                  @if (getSummaryCompetitorItems() && (getSummaryCompetitorItems()!.length - 1) !== $index) {
                    <div class="horizontal-separator"></div>
                  }
                }
              }
            </ng-container>


            @if (registerToRaceFormType === RegisterToRaceFormType.REGISTRATION_INFO
            && registerHelper?.isTeamRegistration()) {
              <!-- Enter and apply coupon for team registration -->
              <div class="horizontal-separator"></div>
              <div class="d-flex align-items-start pt-30-28 pb-38-34">
                <div class="flex-grow-1 me-3">
                  <app-input formControlName="teamCoupon" label="app.register.to.race.coupon"/>
                </div>
                @if (isAfterViewInitPassed) {
                  <div class="mt-30">
                    <app-rounded-button [label]="t('app.register.to.race.apply')" (onClick)="onApplyTeamCoupon()"
                                        [isDisabled]="isApplyTeamCouponButtonDisabled()"
                    />
                  </div>
                }
              </div>
            }

            @if (registerToRaceFormType === RegisterToRaceFormType.CONFIRMATION || registerToRaceFormType
            === RegisterToRaceFormType.PAYMENT) {
              <div class="pb-3">
                <div class="horizontal-separator"></div>
              </div>
              <div class="d-flex px-32 justify-content-start align-items-center">
                <div class="d-flex flex-column">
                  <span class="fs-16 fw-bold">{{ t("event.item.start.date") }}</span>
                  <span class="fs-16">
                                 {{
                      event?.start
                        ? (event!.start! | date: 'dd.MM.yyyy': undefined: translocoService.getActiveLang())
                        : ''
                    }}
                        </span>
                </div>
                <div class="vertical-separator"></div>
                <div class="d-flex flex-column">
                  <span class="fs-16 fw-bold">{{ t("event.item.start.time") }}</span>
                  <span class="fs-16">
                    {{ event?.start ? (event!.start! | localizedDate:'HH:mm') : '' }}
                  </span>
                </div>
                <div class="vertical-separator"></div>
              </div>
            }
          </form>
          <div class="horizontal-separator mt-4 mb-4"></div>
          <div class="pb-2 d-flex justify-content-between px-32 pt-30-28">
            <label>{{ t('app.register.to.race.subtotal') }}:</label>
            <span>{{ getSubTotalPrice() | currency:eventCurrencyLabel }}</span>
          </div>
          <div class="pb-3 d-flex justify-content-between px-32">
            <label>{{ t('app.register.to.race.discount') }}:</label>
            <span>{{ getSubTotalPrice() - getTotalPrice() | currency:eventCurrencyLabel }}</span>
          </div>
          <div class="horizontal-separator mt-4 mb-4"></div>
          <div class="d-flex justify-content-between pb-5 px-32">
            <label class="fw-bold">{{ t('app.register.to.race.total.price') }}:</label>
            <span class="fw-bold">{{ getTotalPrice() | currency:eventCurrencyLabel }}</span>
          </div>
        </div>
      </app-section-card>
      @if (registerToRaceFormType === RegisterToRaceFormType.REGISTRATION_INFO) {
        <div class="d-flex d-xxl-none">
          <ng-container *ngTemplateOutlet="racerButtonsTemplate"></ng-container>
        </div>
      }
    </div>
  </ng-template>
  <ng-template #racerButtonsTemplate>
    <div class="w-100 pt-4">
      <div class="d-flex flex-column flex-md-row align-items-center justify-content-end">
        @if (isAddNewRacerButtonVisible()) {
          <div class="pe-0 pe-md-3 mb-3 mb-md-0" [class.w-100]="isSmallerThanXXL">
            <app-rounded-button [label]="t('app.register.to.race.add.another.racer')" (onClick)="addNewRacer()"
                                [btnClass]="'btn-red' + (isSmallerThanXXL ? ' w-100' : '')"
                                [ngClass]="{'w-100': isSmallerThanXXL}"
            />
          </div>
        }
        <app-rounded-button [label]="t('app.register.to.race.confirm.registration')"
                            (onClick)="confirmRegistration(false)"
                            [btnClass]="'btn-red' + (isSmallerThanXXL ? ' w-100' : '')" [ngClass]="{'w-100':
                            isSmallerThanXXL}"/>

        @if (isManagement) {
          <div class="ps-0 ps-md-3 mt-3 mt-md-0" [class.w-100]="isSmallerThanXXL">
            <app-rounded-button [label]="t('app.register.to.race.without.payment')"
                                (onClick)="confirmRegistration(true)"
                                [btnClass]="'btn-red' + (isSmallerThanXXL ? ' w-100' : '')" [ngClass]="{'w-100':
                            isSmallerThanXXL}"/>
          </div>
        }
      </div>
    </div>
  </ng-template>
</ng-container>


